import { schema } from "normalizr";
import { Warehouse } from "./warehouse";

export const Warehouses = new schema.Array(Warehouse);
